export default __webpack_public_path__ + "static/media/rainbow_13_lightsalmonpink_normal_glasses_small_grimace_normal.693400e9.png";